export const DEFAULT_FORMAT_DATE = "DD/MM/YYYY";
export const DEFAULT_FORMAT_DATE_TIME = "DD/MM/YYYY HH:mm:ss";
